import 'lite-youtube-embed'
import 'lite-vimeo-embed/module/lite-vimeo-embed'
import AsyncAlpine from 'async-alpine'
import AlpineLazyLoadAssets from 'alpine-lazy-load-assets'
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import popover from '@alpinejs/ui/src/popover'
import dialog from '@alpinejs/ui/src/dialog'
import disclosure from '@alpinejs/ui/src/disclosure'
import listbox from '@alpinejs/ui/src/listbox'
import tabs from '@alpinejs/ui/src/tabs'
import iframeResize from 'iframe-resizer/js/iframeResizer'
import 'iframe-resizer/js/iframeResizer.contentWindow'

import 'virtual:svg-icons-register'
import AlertBar from './components/AlertBar'
import SiteHeader from './components/SiteHeader'
import SiteModal from './components/SiteModal'
import SitewidePopUp from './components/SitewidePopUp'
import EventSearch from './components/EventSearch'

import.meta.glob('../img/**/*')

export function init() {
  window.APP = window.APP || {}
  window.Alpine = Alpine

  Alpine.plugin(AlpineLazyLoadAssets)
  Alpine.plugin(dialog)
  Alpine.plugin(disclosure)
  Alpine.plugin(collapse)
  Alpine.plugin(popover)
  Alpine.plugin(tabs)
  Alpine.plugin(focus)
  Alpine.plugin(listbox)

  Alpine.data('AlertBar', AlertBar)
  Alpine.data('SiteHeader', SiteHeader)
  Alpine.data('SiteModal', SiteModal)
  Alpine.data('SitewidePopUp', SitewidePopUp)
  Alpine.data('EventSearch', EventSearch)

  Alpine.plugin(AsyncAlpine)
  // define async components here
  Alpine.asyncData('Splide', () => import('./components/Splide'))
  Alpine.start()

  // Initialize iframe resizer for EveryAction forms
  const eaIframes = document.querySelectorAll('iframe[data-iframe-resize]')
  eaIframes.forEach((iframe) => {
    iframeResize({
      log: false, // window.APP.CONFIG.DEBUG
      checkOrigin: false,
    }, iframe)
  })
}

window.addEventListener('DOMContentLoaded', init)

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
